<template>
  <div class="tw-mb-4 tw-flex tw-items-center tw-gap-x-2">
    <div class="tw-mt-3 tw-flex tw-flex-wrap tw-gap-2">
      <Chip
        v-for="status in selectedStatus"
        :key="status.code"
        variant="monochrome"
        removable
        @remove="removeStatusHandler(status)"
      >
        {{ status.name }}
      </Chip>
      <Chip v-if="sortDirection" variant="monochrome" removable @remove="removeSortDirection">
        {{ sortDirection === 'asc' ? 'Oldest to newest' : 'Newest to oldest' }}
      </Chip>
    </div>
    <div
      v-if="selectedStatus.length > 0 || sortDirection"
      class="tw-mt-3 tw-cursor-pointer tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-underline"
      @click="clearAllHandler"
    >
      Clear all
    </div>
  </div>
</template>

<script setup lang="ts">
import { ActionRequestStatus } from '@torticity/types'

defineProps<{
  selectedStatus: Array<{ code: ActionRequestStatus; name: string }>
  sortDirection?: 'asc' | 'desc' | null
}>()

const emit = defineEmits(['removeStatus', 'removeSortDirection', 'clearAll'])

function removeStatusHandler(status: { code: ActionRequestStatus; name: string }) {
  emit('removeStatus', status)
}

function removeSortDirection() {
  emit('removeSortDirection')
}

function clearAllHandler() {
  emit('clearAll')
}
</script>
